export default {
    props: ["item"],
    name: "item-in-basket",
    data() {
        return {};
    },
    computed: {},
};
